// @ts-check
import { signOut } from '../../data/rest.js';
import { clearSession } from '../../data/metadata-store.js';
import { navigate } from '../../app/router.js';
import { showErrorSnackbar } from '../../ui/snackbar.js';

export async function signOutAndRedirect() {
  try {
    await signOut();
  } catch (error) {
    showErrorSnackbar(error);
  }
  clearSession();
  navigate('/welcome', { replace: true });
}
